import React from 'react'

function PagosEnLineaScreen() {
  return (
    <div>PagosEnLineaScreen</div>
  )
}

export default PagosEnLineaScreen